export default "__VITE_ASSET__DEadR6Lm__"